import { Col, Row, Table, Input, Button, Progress } from "reactstrap";
import { useContext, useEffect, useState, useRef } from "react";
import { UpdateRemoteControl, addRemoteControl, deleteRemoteControl, getDeviceConfig, getDeviceId, remoteControl } from "../../api/api";
import Spinner from "../../commons/Spinner";
import { addDays, format } from "date-fns";
import { SchoolContext } from "../../context/SchoolContext";
import { useHistory } from "react-router-dom";
import { formatValue, getRandomValue, idExists } from "../../utils/NumberUtils";
import Select, { components } from "react-select"
import { ConfirmEditModal, LoadingModal, SuccessModal, TableEditModal, TableModal } from "../../commons/BaseModal";
import { modeType, statusType } from "../../utils/RemoteUtils";
import { ArrowDown, ArrowUp } from "../../commons/Logo";
import { utcToZonedTime } from "date-fns-tz";
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css'
import { ja } from "date-fns/locale";

const RemoteControl = ({ controlType }) => {

    const { schoolList, setSchool } = useContext(SchoolContext)

    // const [currentDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const authToken = localStorage.getItem('accessToken');
    const [deviceId, setDeviceId] = useState(null);
    const [dateFrom, setDateFrom] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
    const [startTime, setStartTime] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm'));
    const [visible, setVisible] = useState(true);
    const history = useHistory();
    const pathname = history["location"].pathname
    const school_id = Number(pathname.split('/').pop());

    const [active, setActive] = useState('btpcs');
    const [chargeCycle, setChargeCycle] = useState(null);
    const [chargeCycleAmount, setChargeCycleAmount] = useState(null);
    const [ouputControl, setOuputControl] = useState(null);
    const [selectedMode, setSelectedMode] = useState('charge');
    const [deviceArr, setDeviceArr] = useState(null);
    const [options, setOptions] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState([]);
    const [intervalOpen, setIntervalOpen] = useState(false);

    const [openInfo, setOpenInfo] = useState(false);
    const [msg, setMsg] = useState('');
    const [confirm, setConfirm] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const intervalOptions = [
        { label: '毎日', value: 'daily' },
        { label: '毎週', value: 'weekly' },
        { label: '毎月', value: 'monthly' },
        { label: '毎年', value: 'yearly' }
    ];
    const [groupData, setGroupData] = useState([]);
    const [checkedData, setCheckedData] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [hideTr, setHideTr] = useState({})
    const [interval, setInterval] = useState(intervalOptions[0]);
    const [confirmEdit, setConfirmEdit] = useState(false);
    const targetRef = useRef();
    const rateRef = useRef();
    const dropdownRef = useRef(null);
    const timeRef = useRef();
    const [apiStatus, setApiStatus] = useState(false);
    const [isEmpty, setisEmpty] = useState(false);
    const [targetFocus, setTargetFocus] = useState('');
    const [timeFocus, setTimeFocus] = useState(false);
    const [rateFocus, setRateFocus] = useState('');
    const [updateType, setUpdateType] = useState(null);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [progressValue, setProgressValue] = useState(0);

    // UseEffect

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        const Value = JSON.parse(localStorage.getItem('schools'));
        const schoolObj = { id: school_id };
        if (Value && Value !== null && Value.some(obj => obj.id === schoolObj.id)) {
            setDeviceId(Value.find(obj => obj.id === schoolObj.id).device_id);
            setSchool(Number(school_id));
            setLoading(false);
        } else {
            if (schoolList.length > 0) {
                if (idExists(schoolList, school_id)) {
                    setSchool(school_id);
                    const Id = async () => {
                        const res = await getDeviceId(schoolList[school_id - 1].place_id, authToken, signal);
                        if (res && res.sems_device_id) {
                            const value = localStorage.getItem('schools');
                            const schools = value ? JSON.parse(value) : [];
                            const schoolObj = { id: school_id, device_id: res.sems_device_id };
                            schools.push(schoolObj);
                            localStorage.setItem('schools', JSON.stringify(schools));
                            setDeviceId(res.sems_device_id)
                        }
                        setLoading(false);
                    }
                    Id(signal);

                    return () => {
                        controller.abort();
                    };
                } else {
                    history.push('/home')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, schoolList, school_id])
    const handleTimeChange = (e) => {
        const inputValue = e.target.value;
        // Split the input value into hours and minutes
        const [hours, minutes] = inputValue.split(':').map((value) => parseInt(value));
        // Ensure hours and minutes are in two-digit format
        const formattedHours = hours < 10 ? `0${hours}` : hours;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        // Construct the formatted time string in the desired format (e.g., "HH:MM")
        const formattedTime = `${formattedHours}:${formattedMinutes}`;
        // Update the state with the formatted time
        setStartTime(formattedTime);
        console.log(e.target.value, formattedTime, 'hello')
    };
    useEffect(() => {
        if (deviceId !== null) {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;
            const deviceData = async (signal) => {
                const deviceDataFetched = await getDeviceConfig(authToken, deviceId, { configType: 'network_config' }, signal);
                if (deviceDataFetched.length > 0) {
                    const batArr = deviceDataFetched.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

                    const pcsArr = deviceDataFetched.filter(el => el.device_name.toLowerCase().startsWith('pv_pcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
                    setDeviceArr([...batArr, ...pcsArr]);
                }
            }
            const remoteData = async (signal) => {
                const data = await remoteControl(authToken, deviceId, 30, signal);
                setGroupData(data)
                setLoading(false);
            }

            deviceData(signal);
            remoteData(signal);

            return () => {
                controller.abort();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId, controlType])


    useEffect(() => {
        if (deviceArr !== null) {
            if (active === 'btpcs') {
                setOptions(deviceArr
                    .filter(item => item.device_id.toLowerCase().startsWith('btpcs'))
                    .map(device => ({
                        value: device.device_id,
                        label: device.device_id,
                    })));
            } else {
                setOptions(deviceArr.filter(item =>
                    (item.device_name.toLowerCase().startsWith('pv_pcs') && !item.device_id.toLowerCase().includes('kwtr'))
                ).map(device => ({
                    value: device.device_id,
                    label: device.device_id,
                })));
            }
        }
    }, [active, deviceArr])

    useEffect(() => {
        const favicon = document.querySelector("link[rel~='icon']");
        if (apiStatus) {
            favicon.href = "/img/loading.gif";
        } else {
            favicon.href = "/favicon-3.ico";
        }
    }, [apiStatus]);

    useEffect(() => {
        const clickListener = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
                setSelectedDevices([]);
            }
        };

        document.addEventListener('click', clickListener);

        return () => {
            document.removeEventListener('click', clickListener);
        };
    }, []);

    useEffect(() => {
        setIsSelectAll(selectedDevices.length === options.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDevices]);

    // Modal Toggle

    const toggleModal = () => {
        setOpenModal(!openModal);
        // setSelectedOption([]);
        // setStartTime(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm'));
        // setDateFrom(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
        // setChargeCycle(null);
        // setSelectedMode('charge');
        // setChargeCycleAmount(null);
    }

    const toggleConfirm = () => {
        setSelectedRow(null);
        setConfirm(!confirm);
    }

    const toggleEditModal = () => {
        if (selectedRow !== null) {
            setEditModal(!editModal);
        }
    }

    const handleCancel = () => {
        setSelectedRow(null);
        setEditModal(false);
    }

    // Custom Table Render 

    const renderTr = (data, index) => {
        let trmap = []
        if (data.controls.length > 1) {
            data.controls.forEach((element, i) => {
                trmap.push(i === 0 ?
                    <tr key={index}>
                        <td>
                            <input type="checkbox" disabled={data.status.toLowerCase() !== 'scheduled'} checked={selectedRow === index} name="groupSelection" onChange={() => handleCheck(index)} /> {index + 1}
                            {data.controls.length > 1 && <span className="text-success font-weight-bolder remote__arrow" onClick={() => handleTrHide(index)}>{hideTr[index] ? hideTr[index].hide ? <ArrowDown /> : <ArrowUp /> : <ArrowDown />}</span>}
                        </td>
                        <td>{element.device_id}</td>
                        <td>{data.start_datetime}</td>
                        <td>{modeType(element.control_mode)}</td>
                        <td>{data.controls[i].target ? formatValue(data.controls[i].target) : '---'}</td>
                        <td>{data.controls[i].rate ? formatValue(data.controls[i].rate) : '---'}</td>
                        <td>{statusType(data.status)}</td>
                    </tr>
                    : <tr key={data.control_id + getRandomValue()}
                        className={`${hideTr[index] ? hideTr[index].hide ? "hideRow" : "" : "hideRow"}`}
                    >
                        <td className="pl-4"></td>
                        <td>{element.device_id}</td>
                        <td>{data.start_datetime}</td>
                        <td>{modeType(element.control_mode)}</td>
                        <td>{data.controls[i].target ? formatValue(data.controls[i].target) : '---'}</td>
                        <td>{data.controls[i].rate ? formatValue(data.controls[i].rate) : '---'}</td>
                        <td>{statusType(data.status)}</td>
                    </tr>)
            });
        } else {
            trmap.push(
                <tr key={index}>
                    <td>
                        <input type="checkbox" disabled={data.status.toLowerCase() !== 'scheduled'} checked={selectedRow === index} name="groupSelection" onChange={() => handleCheck(index)} /> {index + 1}
                    </td>
                    <td>{data.controls[0].device_id}</td>
                    <td>{data.start_datetime}</td>
                    <td>{modeType(data.controls[0].control_mode)}</td>
                    <td>{data.controls[0].target ? formatValue(data.controls[0].target) : '---'}</td>
                    <td>{data.controls[0].rate ? formatValue(data.controls[0].rate) : '---'}</td>
                    <td>{statusType(data.status)}</td>
                </tr>
            )
        }
        return trmap;
    }

    const IntervalOption = (props) => {
        return (
            <div style={{
                padding: `${props.value === "*" ? '10px 15px 0px 15px' : '0px 15px'}`,
                backgroundColor: "#EFF8FE",
            }}>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };

    const IntervalcustomStyles = {
        control: styles => ({ ...styles, backgroundColor: 'white' }),
        option: (styles) => {
            return {
                ...styles,
                backgroundColor: "#233c6b",
                color: "#fff",
                textAlign: "left",
                border: "1px solid #EFF8FE",
                padding: "8px 12px 0px 12px",
                width: "150px",
                marginLeft: '-15px',
            }
        },
        menuList: (provided) => ({
            ...provided,
            backgroundColor: '#EFF8FE',
            textAlign: 'center',
            width: "150px",
            marginLeft: '-65px',
        }),
    };

    const IntervalCustomMenuList = (props) => {
        return (
            <components.MenuList {...props}>
                <div className="px-2">繰り返し期間を選択してくだいさい</div>
                {props.children}
                <button className="btn__select mt-2" onClick={() => setIntervalOpen(false)}>OK / 閉じる</button>
            </components.MenuList>
        );
    };

    // Handle Functions

    const handleTrHide = (index) => {
        setHideTr(
            {
                ...hideTr,
                [index]: {
                    hide: hideTr[index] ? !hideTr[index].hide : false,
                }
            })
    }
    const handleRemote = async () => {
        setOpenModal(false);
        setUpdateType("送信")
        let controls = {};
        selectedOption.slice(selectedOption[0].value === "*" ? 1 : 0).forEach((v) => {
            if (selectedMode === 'standby' || selectedMode === 'auto') {
                controls[v.value] = {
                    control_mode: selectedMode.toUpperCase()
                }
            } else {
                controls[v.value] = {
                    control_mode: selectedMode.toUpperCase(),
                    rate: chargeCycleAmount * 1000,
                    target: chargeCycle * 1000
                }
            }
        });
        const params = {
            sems_device_id: deviceId,
            controls: controls,
            start_datetime: dateFrom + ' ' + startTime + ':00',
        }
        setApiStatus(true)
        const data = await addRemoteControl(authToken, params);
        if (data.status === 200) {
            setMsg('送信が成功しました。')
            const response = await remoteControl(authToken, deviceId, 30);
            setGroupData(response);
            setSelectedRow(null);
            setOpenInfo(true);
        } else {
            setMsg('送信が失敗しました。');
            setOpenInfo(true);
        }
        setApiStatus(false)
        setSelectedOption([]);
        setStartTime(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm'));
        setDateFrom(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
        setChargeCycle(null);
        setSelectedMode('charge');
        setChargeCycleAmount(null);
        setUpdateType(null);
        focusCreatable();
    }

    const handleDateChangeFrom = (e) => {
        let changedDate;
        if (e === null || e === '') {
            changedDate = ''
        } else {
            changedDate = format((new Date(e)), 'yyy-MM-dd');
        }
        setDateFrom(changedDate);
    };


    const handleSubmit = () => {
        // Guard clauses for setting focus
        if (selectedOption.length === 0) {
            setisEmpty(true);
            focusCreatable();
        }

        if (chargeCycle === null) {
            setTargetFocus('値を入力してください。');
            focusTarget();
        }
        if (chargeCycle === 0) {
            setTargetFocus('最小値は0.1です。');
            focusTarget();
        }
        if (chargeCycle > 20) {
            setTargetFocus('最大値は20です。');
            focusTarget();
        }

        if (chargeCycleAmount === null) {
            setRateFocus('値を入力してください。');
            focusRate();
        }
        if (chargeCycleAmount === 0) {
            setRateFocus('最小値は0.1です。');
            focusRate();
        }
        if (chargeCycleAmount > 4) {
            setRateFocus('最大値は4です。');
            focusRate();
        }
        if (startTime === "") {
            setTimeFocus(true);
            focusTime();
        }
        //Guard clause for opening the modal
        if ((selectedMode === 'standby' || selectedMode === 'auto') && selectedOption.length > 0 && !timeFocus) {
            openModals();
            return;
        }

        if (selectedOption.length > 0 && chargeCycle !== null && chargeCycleAmount !== null && !timeFocus && targetFocus === '' && rateFocus === '') {
            openModals();
            return;
        }
    }

    const openModals = () => {
        setisEmpty(false);
        setTargetFocus('');
        setRateFocus('');
        setOpenModal(true);
    }


    const focusCreatable = () => {
        dropdownRef.current?.focus();
    };

    const focusTarget = () => {
        targetRef.current?.focus();
    };

    const focusRate = () => {
        rateRef.current?.focus();
    };

    const focusTime = () => {
        timeRef.current?.focus();
    };

    const handleIntervalChange = (value) => {
        setInterval(value)
    };

    const handleCheck = (i) => {
        if (selectedRow === i) {
            setSelectedRow(null);
            setCheckedData({});
        } else {
            setSelectedRow(i);
            setCheckedData(groupData.records[i]);
        }
    }

    const handleGroupDelete = async () => {
        toggleConfirm();
        setApiStatus(true);
        setUpdateType('削除');
        const data = await deleteRemoteControl(authToken, deviceId, groupData.records[selectedRow].control_id);
        if (data.status === 200) {
            setMsg('削除が成功しました。')
            const response = await remoteControl(authToken, deviceId, 30);
            setGroupData(response);
            setSelectedRow(null);
            setOpenInfo(true);
        } else {
            setMsg('削除が失敗しました。');
            setOpenInfo(true);
        }
        setApiStatus(false);
        setUpdateType(null);
    }
    const handleOpenInfo = async () => {
        setOpenInfo(false);
    }

    const handleEditModal = (e) => {
        setEditModal(false);
        setConfirmEdit(true);
        setCheckedData(e);
    }

    const handleEditConfirmation = async () => {
        setConfirmEdit(false);
        setUpdateType('更新')
        let controls = {};
        checkedData.controls.forEach((v) => {
            if (v.control_mode.toLowerCase() === 'standby' || v.control_mode.toLowerCase() === 'auto') {
                controls[v.device_id] = {
                    control_mode: v.control_mode.toUpperCase()
                }
            } else {
                controls[v.device_id] = {
                    control_mode: v.control_mode.toUpperCase(),
                    rate: v.rate > 4 ? v.rate : v.rate * 1000,
                    target: v.target > 20 ? v.target : v.target * 1000
                }
            }
        });
        const params = {
            sems_device_id: deviceId,
            control_id: checkedData.control_id,
            controls: controls,
            start_datetime: checkedData.start_datetime,
        }

        setApiStatus(true);
        const data = await UpdateRemoteControl(authToken, params);
        if (data.status === 200) {
            setMsg('更新が成功しました。')
            const response = await remoteControl(authToken, deviceId, 30);
            setGroupData(response);
            setOpenInfo(true);
        } else {
            setMsg('更新が失敗しました。');
            setOpenInfo(true);
        }
        setApiStatus(false);
        setSelectedRow(null);
        setUpdateType(null);
    }

    const handleSelectAll = (e) => {
        setIsSelectAll(e.target.checked);
        if (e.target.checked) {
            setSelectedDevices(options.filter(option => option.device_id !== ''));
            setisEmpty(false);
        } else {
            setSelectedDevices([]);
        }
    };

    const handleCheckboxChange = (device, checked) => {
        let newSelectedDevices = [...selectedDevices];

        if (checked && device.value !== '') {
            newSelectedDevices.push(device);
        } else {
            newSelectedDevices = newSelectedDevices.filter(dev => dev.value !== device.value);
        }

        // Sort the newSelectedDevices array by the numeric value property
        newSelectedDevices.sort((a, b) => {
            const numA = Number(a.value.replace('BTPCS', ''));
            const numB = Number(b.value.replace('BTPCS', ''));
            return numA - numB;
        });

        setSelectedDevices(newSelectedDevices);
    }

    const handleScroll = async () => {
        const target = document.getElementById('remote_groupData');
        const scrollHeight = target.scrollHeight;
        const scrollTop = target.scrollTop;
        const clientHeight = target.clientHeight;
        if (Math.abs(scrollHeight - clientHeight - scrollTop) <= 2 && groupData.lastEvaluatedKey !== null) {
            let i = 0;
            setTableLoading(true);
            setProgressValue(i);
            const increment = () => {
                if (i < 101) {
                    setProgressValue(i++);
                    setTimeout(increment, 10);
                }
            };
            increment();
            if (!tableLoading) {
                try {
                    const controller = new AbortController();
                    const signal = controller.signal;
                    const response = await remoteControl(authToken, deviceId, 30, signal, groupData.lastEvaluatedKey);
                    setProgressValue(100);
                    setGroupData((prevState) => ({
                        ...prevState,
                        lastEvaluatedKey: response.lastEvaluatedKey,
                        records: [...prevState.records, ...response.records],
                    }));
                    setTableLoading(false);
                    return () => {
                        controller.abort();
                    };
                } catch {
                    setTableLoading(false);
                }
            }
        }
    }

    return (
        <> {loading ? <Spinner /> : <section>
            <Col className="d-flex flex-row deviceSection">
                <Col className={`${visible ? "col1" : "col1hide"} pb-3 side-menubar`} >
                    <Row className="justify-content-between h-100 content-mobile-error">
                        {visible ? <Col className="pt-2 menubar">
                            <Row>
                                <span className="remote_text mx-auto">
                                    {controlType === 'schedule' ? '設定(繰)' : '設定'}
                                </span>
                            </Row>
                            <Row className="mt-3 d-flex flex-column">
                                <Col>
                                    <Row className="bg_errorP justify-content-center headingSpace">
                                        <span className="remote_head">デバイス</span>
                                    </Row>

                                    <Row className="bg_errorP mt-3 p-1">
                                        <div role='button' className={`remote_toggle col-md-6 p-0 ${active === 'btpcs' ? 'remote_active' : ''}`} onClick={() => {
                                            setActive('btpcs');
                                            setSelectedOption([]);
                                        }}>
                                            BTPCS
                                        </div>
                                        <div role='button' className={`remote_toggle col-md-6 p-0 ${active === 'pvpcs' ? 'remote_active' : ''}`}
                                        // onClick={() => {
                                        //     setActive('pvpcs');
                                        //     setSelectedOption([]);
                                        // }}
                                        >
                                            PVPCS
                                        </div>
                                    </Row>
                                    <Row className="mt-3">
                                        <div className={`dropdown ${isEmpty && 'empty'}`} ref={dropdownRef} tabIndex="0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div style={{ width: "100%" }}>
                                                    <span style={{ fontSize: "14px" }}>{selectedOption.length > 0 ? selectedOption.length === options.length ? "すべてのデバイス" : selectedOption.length > 1 ? selectedOption[0].label + " ..." : selectedOption[0].label : 'デバイスを選択'}</span>
                                                </div>
                                                <div style={{ paddingRight: "2px", cursor: "pointer" }}>
                                                    {isEmpty ?
                                                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="43" height="35" viewBox="0 4 60 36"><rect width="60.3209" rx="6" fill="#FF0000" fill-opacity="0.73" height="44" onClick={() => { setIsOpen(!isOpen); setSelectedDevices(selectedOption) }}></rect><path d="M38.75 19.375L30.5 27.625L22.25 19.375" stroke="white" stroke-width="2"></path></svg>
                                                        : <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="43" height="35" viewBox="0 4 60 36"><rect width="60.3209" rx="6" fill="#233C6B" fill-opacity="0.73" height="44" onClick={() => { setIsOpen(!isOpen); setSelectedDevices(selectedOption) }}></rect><path d="M38.75 19.375L30.5 27.625L22.25 19.375" stroke="white" stroke-width="2"></path></svg>}
                                                </div>
                                            </div>
                                            {isOpen && (
                                                <div className={`dropdown-content ${isOpen && 'show'}`}>
                                                    <div className="py-1 d-flex align-items-center px-2" style={{
                                                        backgroundColor: "#233c6b",
                                                        color: "#fff",
                                                        borderRadius: '3px'
                                                    }}>
                                                        <input type='checkbox' className="" style={{ cursor: "pointer" }} onChange={
                                                            handleSelectAll} checked={isSelectAll} />
                                                        <div className="pl-1 selectBoxLabel">すべて選択</div>
                                                    </div>
                                                    <div className="dropDown_options">
                                                        {options.map((device, index) => (
                                                            <div key={index} className="py-1 d-flex align-items-center px-2">
                                                                <input type='checkbox' className="" style={{ cursor: "pointer" }}
                                                                    onChange={(e) => handleCheckboxChange(device, e.target.checked)}
                                                                    checked={selectedDevices.some(dev => dev.value === device.value)}
                                                                />
                                                                <div className="pl-1 selectBoxOptions">{device.label}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div style={{ textAlign: "center" }}>
                                                        <button className="btn__remotePrimary mt-2" onClick={() => {
                                                            setIsOpen(!isOpen);
                                                            setSelectedOption(selectedDevices);
                                                            if (selectedDevices.length > 0) {
                                                                setisEmpty(false);
                                                            }
                                                        }}>
                                                            OK / 閉じる
                                                        </button>
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                        {isEmpty && <span className="remote_req">デバイスを選択してください。</span>}
                                    </Row>
                                </Col>

                                <Col className="mt-4">
                                    <Row className="bg_errorP justify-content-center align-items-center headingSpace">
                                        {controlType === 'schedule' ?
                                            <>
                                                <span className="remote_text__large">繰日時</span>
                                                <Select
                                                    options={intervalOptions}
                                                    components={{
                                                        Option: IntervalOption,
                                                        MenuList: IntervalCustomMenuList,
                                                    }}
                                                    isSearchable={false}
                                                    onChange={handleIntervalChange}
                                                    closeMenuOnSelect={false}
                                                    menuIsOpen={intervalOpen}
                                                    onMenuClose={() => setIntervalOpen(false)}
                                                    onMenuOpen={() => setIntervalOpen(true)}
                                                    hideSelectedOptions={false}
                                                    value={interval}
                                                    styles={IntervalcustomStyles}
                                                />
                                            </>
                                            : <span className="remote_head">開始日時</span>}
                                    </Row>
                                    <Row className="mt-3">
                                        <DatePicker className='remote_time remote__input remote_datepicker'
                                            showIcon
                                            value={dateFrom}
                                            portalId="root-portal"
                                            locale={ja}
                                            icon={
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => setOpenCalendar(!openCalendar)}>
                                                    <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                                    <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                                    <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                    <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                    <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                    <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                    <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                    <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                </svg>
                                            }
                                            minDate={new Date()}
                                            maxDate={addDays(new Date(), 30)}
                                            onChange={(e) => {
                                                handleDateChangeFrom(e);
                                                setOpenCalendar(false)
                                            }}
                                            open={openCalendar}
                                            // onInputClick={() => setOpenCalendar(!openCalendar)}
                                            onClickOutside={() => setOpenCalendar(false)}
                                            popperPlacement="bottom"
                                        />
                                    </Row>
                                    <Row className="mt-3">
                                        <Input type="time" bsSize="sm"
                                            // className="remote_time remote__input"
                                            className={`remote_time remote__input ${timeFocus && 'empty'}`}
                                            onChange={(e) => {
                                                setStartTime(e.target.value);
                                                handleTimeChange(e);
                                                if (e.target.value !== '') {
                                                    setTimeFocus(false);
                                                } else {
                                                    setTimeFocus(true);
                                                }
                                            }}
                                            value={startTime}
                                            // onKeyDown={(e) => e.preventDefault()}
                                            ref={timeRef}

                                        />
                                        {/* <img src="/img/timer.svg" className="timerIcon" /> */}
                                        {timeFocus && <span className="remote_req">開始時刻を入力してください。</span>}
                                        <span className="remote_timeMsg">
                                            ※現在時刻から30分以内は即時実行されます
                                        </span>
                                    </Row>
                                </Col>

                                {controlType === 'schedule' && <Col className="mt-4">
                                    <Row className="">
                                        <u><span className="remote_text__large">次の 5 つの予定日時</span></u>
                                    </Row>
                                    <Row className="mt-2 p-0 text__small">
                                        <span>1. 24日10月2023 12:00 JST</span>
                                        <span>2. 24日11月2023 12:00 JST</span>
                                        <span>3. 24日12月2023 12:00 JST</span>
                                        <span>4. 24日01月2023 12:00 JST</span>
                                        <span>5. 24日02月2023 12:00 JST</span>
                                    </Row>
                                </Col>}

                                {active && active === 'btpcs' && <><Col className="mt-4">
                                    <Row className="bg_errorP  justify-content-center headingSpace">
                                        <span className="remote_head">モード</span>
                                    </Row>
                                    <Row className="px-2 mt-3">
                                        <div className="col mx-4">
                                            <Row className="d-flex mode-list">
                                                <input type="radio" id="mode" className="checkboxScale" checked={selectedMode === "charge"} value={"charge"} onChange={() => {
                                                    setSelectedMode("charge")
                                                }} />
                                                <div className="d-flex chargeItem">
                                                    <div className="modeSelect remote__charge">
                                                    </div>
                                                    <span className="remote_head">充電 </span>
                                                </div>

                                            </Row>
                                            <Row className="mt-3 d-flex mode-list">
                                                <input type="radio" id="mode" className="checkboxScale" checked={selectedMode === "discharge"} value={"discharge"} onChange={() => {
                                                    setSelectedMode("discharge")
                                                }} />
                                                <div className="d-flex chargeItem">
                                                    <div className="modeSelect remote__discharge">
                                                    </div>
                                                    <span className="remote_head">放電 </span>
                                                </div>

                                            </Row>
                                            <Row className="mt-3 d-flex mode-list">
                                                <input type="radio" id="mode" className="checkboxScale" checked={selectedMode === 'standby'} value={"standby"} onChange={() => {
                                                    setSelectedMode("standby");
                                                    setChargeCycle(null);
                                                    setChargeCycleAmount(null);
                                                    setRateFocus('');
                                                    setTargetFocus('');

                                                }} />
                                                <div className="d-flex chargeItem">
                                                    <div className="modeSelect remote__chargecycle">
                                                    </div>
                                                    <span className="remote_head">待機 </span>
                                                </div>

                                            </Row>
                                            <Row className="mt-3 d-flex mode-list">
                                                <input type="radio" id="mode" className="checkboxScale" checked={selectedMode === 'auto'} value={"auto"} onChange={() => {
                                                    setSelectedMode("auto");
                                                    setChargeCycle(null);
                                                    setChargeCycleAmount(null);
                                                    setRateFocus('');
                                                    setTargetFocus('');
                                                }} />
                                                <div className="d-flex chargeItem">
                                                    <div className="modeSelect remote__chargeAmount pl-1">
                                                    </div>
                                                    <span className="remote_head">自動 </span>
                                                </div>

                                            </Row>
                                        </div>
                                    </Row>
                                </Col>

                                    {(selectedMode === 'charge' || selectedMode === 'discharge') && <><Col className="mt-4">
                                        <Row className="bg_errorP  justify-content-center headingSpace">
                                            <span className="remote_head">充放電量[kWh]</span>
                                        </Row><Row className="mt-3">
                                            <Input ref={targetRef} type="number" bsSize="sm" className={`remote_target ${targetFocus !== '' && 'empty'}`} min={0.1} step={0.1} max={20}
                                                onChange={(e) => {
                                                    let value = parseFloat(e.target.value);
                                                    const re = /^[0-9\b]+(\.[0-9]{0,1})?$/; // regex to match numbers/decimals up to 1 decimal places
                                                    if (re.test(value)) { // check if input is empty or matches regex           
                                                        value = Number(value).toString();
                                                        if (value >= 0.1 && value <= 20) {
                                                            setTargetFocus('');
                                                            setChargeCycle(value);
                                                        } else {
                                                            if (value <= 0) {
                                                                setTargetFocus('最小値は0.1です。');
                                                                setChargeCycle(value);
                                                            }
                                                            // else {
                                                            //     setTargetFocus('最大値は20です。');
                                                            // }
                                                        }
                                                    } else if (isNaN(value)) {
                                                        setChargeCycle(null);
                                                        setTargetFocus('値を入力してください。');
                                                    }
                                                }}

                                                onKeyDown={(e) => {
                                                    if (e.code === 'Minus' || e.code === 'NumpadSubtract' || e.code === 'Equal' || e.code === 'NumpadAdd' || e.code === "KeyE") {
                                                        e.preventDefault();
                                                    } else if (e.target.value >= 20 && e.code !== 'Backspace' && e.code !== 'Delete' && e.code !== 'ArrowLeft' && e.code !== 'ArrowRight') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={chargeCycle ? chargeCycle : ''}
                                                placeholder="0.1~20"
                                                invalid={targetFocus}
                                            />
                                            {targetFocus !== '' && <span className="remote_req">{targetFocus}</span>}
                                        </Row>
                                    </Col>
                                        <Col className="mt-4">
                                            <Row className="bg_errorP headingSpace justify-content-center">
                                                <span className="remote_head">充放電電力[kW]</span>
                                            </Row><Row className="mt-3">
                                                <Input ref={rateRef} type="number" bsSize="sm" className={`${rateFocus !== '' ? 'empty__rate' : 'remote_rate'}`} min={0.1} max={4} step={0.1}
                                                    onChange={(e) => {
                                                        let value = parseFloat(e.target.value);
                                                        const re = /^[0-9\b]+(\.[0-9]{0,1})?$/; // regex to match numbers/decimals up to 1 decimal places
                                                        if (re.test(value)) { // check if input is empty or matches regex
                                                            value = Number(value).toString();
                                                            if (value >= 0.1 && value <= 4) {
                                                                setRateFocus('');
                                                                setChargeCycleAmount(value);
                                                            } else {
                                                                if (value <= 0) {
                                                                    setRateFocus('最小値は0.1です。');
                                                                    setChargeCycleAmount(value);
                                                                }
                                                                // else {
                                                                //     setRateFocus('最大値は4です。');
                                                                // }
                                                            }
                                                        } else if (isNaN(value)) {
                                                            setChargeCycleAmount(null);
                                                            setRateFocus('値を入力してください。');
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.code === 'Minus' || e.code === 'NumpadSubtract' || e.code === 'Equal' || e.code === 'NumpadAdd' || e.code === "KeyE") {
                                                            e.preventDefault();
                                                        } else if (e.target.value >= 4 && e.code !== 'Backspace' && e.code !== 'Delete' && e.code !== 'ArrowLeft' && e.code !== 'ArrowRight') {
                                                            e.preventDefault();
                                                        }
                                                    }}

                                                    placeholder="0.1~4"
                                                    value={chargeCycleAmount ? chargeCycleAmount : ''}
                                                    invalid={rateFocus}
                                                />
                                                {rateFocus !== '' && <span className="remote_req">{rateFocus}</span>}
                                            </Row>
                                        </Col> </>}

                                </>}
                                {active && active === 'pvpcs' && <><Col className="mt-4">
                                    <Row className="bg_errorP  justify-content-center">
                                        <span className="remote_head mr-4">出力制御(%)</span>
                                    </Row><Row className="mt-3">
                                        <Input type="number" bsSize="sm" className="remote_target" min={0} max={100}
                                            onChange={(e) => {
                                                if (e.target.value >= 0.1 && e.target.value <= 100) {
                                                    setOuputControl(e.target.value)
                                                }
                                            }}
                                            placeholder="0"
                                            value={ouputControl}
                                        />
                                    </Row>
                                </Col></>}
                                <Col className="mt-5"><Row className="px-2 pb-2">
                                    <Button className="btn__remoteSetting" onClick={() => {
                                        if (!isOpen) {
                                            handleSubmit()
                                        }
                                    }}>
                                        送信
                                    </Button>
                                </Row>
                                </Col>
                            </Row>
                        </Col> : ''}
                        <div className="collapse_bar" onClick={() => { setVisible(!visible) }}>
                            {/* <div className="collaps_btn">
                                {visible ? <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" fill="#fff" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                </svg> :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" fill="#fff" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                    </svg>}
                            </div> */}
                        </div>
                    </Row>
                </Col >
                <Col className={`${visible ? "" : "col1hide"} content-bar`}>
                    <Row className="pt-2">
                        <span className="remote_title mx-auto">遠隔制御履歴</span>
                    </Row>
                    <Row className="mt-2 table__container">
                        <Col className="table__container">
                            <Row className="d-flex flex-row-reverse mb-3 pr-4 action-buttons">
                                {selectedRow !== null &&
                                    <>
                                        <button className="btn__danger" onClick={() => setConfirm(true)}>削除</button>
                                        <button className="mr-2 btn__primary" onClick={() => toggleEditModal()}>編集</button></>}
                            </Row>
                            {tableLoading &&
                                <Progress animated={true} color="info" value={progressValue} style={{
                                    height: "5px"
                                }} />

                            }
                            <div className="remote__table" id="remote_groupData" onScroll={handleScroll}>
                                <Table className="remote_groupData">
                                    <thead>
                                        <th>No.</th>
                                        <th>デバイス名</th>
                                        <th>開始時間</th>
                                        <th>モード</th>
                                        <th>充放電電量[kWh]</th>
                                        <th>充放電電力[kW]</th>
                                        <th>状態</th>
                                    </thead>
                                    <tbody>
                                        {groupData.records && groupData.records.length > 0 ? groupData.records.map((data, index) => {
                                            return renderTr(data, index)
                                        }) : ""}

                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Col >

            {/* Modal */}
            {
                openModal && <TableModal
                    open={openModal}
                    btnLeft='キャンセル'
                    btnRight='送信'
                    handleLeft={() => toggleModal()}
                    handleRight={() => handleRemote()}
                    title='確認画面'
                    content={selectedOption}
                    mode={selectedMode}
                    charge={chargeCycle}
                    chargeAmount={chargeCycleAmount}
                    message='送信内容を確認ください。'
                    dateTime={`${dateFrom} ${startTime}:00`}
                />
            }
            {
                editModal &&
                <TableEditModal
                    open={editModal}
                    btnLeft='キャンセル'
                    btnRight='確認'
                    handleLeft={() => handleCancel()}
                    handleRight={(e) => handleEditModal(e)}
                    content={checkedData}
                    id={selectedRow + 1}
                    devices={options}
                />
            }



            {
                confirmEdit && <ConfirmEditModal
                    open={confirmEdit}
                    btnLeft='キャンセル'
                    btnRight='更新'
                    handleLeft={() => { setConfirmEdit(false); setEditModal(true) }}
                    handleRight={() => handleEditConfirmation()}
                    title='確認画面'
                    content={checkedData}
                    message='更新内容を確認ください。'
                    id={selectedRow + 1}
                />
            }

            <SuccessModal
                open={openInfo}
                content={msg}
                handleButton={() => handleOpenInfo()}
            />

            {
                confirm && <ConfirmEditModal
                    open={confirm}
                    btnLeft='キャンセル'
                    btnRight='削除'
                    handleLeft={() => toggleConfirm()}
                    handleRight={() => handleGroupDelete()}
                    handleOpen={() => toggleConfirm()}
                    title='確認画面'
                    content={checkedData}
                    message='以下の内容を本当に削除しますか。'
                    id={selectedRow + 1}
                    display={false}
                />
            }


            {apiStatus && <LoadingModal
                open={apiStatus}
                content={
                    <>
                        <span className="remoteModal_status">
                            {updateType}中です。
                        </span>
                        <span className="remoteModal_status">しばらくお待ちください。</span>
                    </>
                }
            />}

        </section >} </>
    );

}

export default RemoteControl;